var map = {
	"./bigdata.svg": 35663,
	"./desktop.svg": 85510,
	"./devops.svg": 30573,
	"./dotnet.png": 85321,
	"./frontend.svg": 49145,
	"./iot.svg": 39353,
	"./java.png": 27473,
	"./mobile.svg": 81769,
	"./mvp.svg": 52325,
	"./nodejs.png": 54631,
	"./nodejs.svg": 10521,
	"./php.svg": 47580,
	"./python.png": 50133,
	"./react.png": 70876,
	"./rust.svg": 75995,
	"./sisint.svg": 25996,
	"./tech.png": 67613,
	"./tech2.png": 97268,
	"./vr.svg": 36562,
	"./webapp.svg": 49133
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 54126;